import React, { ReactElement } from 'react'
import { Amplify, Auth } from 'aws-amplify'
import awsConfig from './aws-exports'
import { BUILD_ENV, GOOGLE_ANALYTICS_KEY, isProdNodeEnv } from 'constants/Utils.constants'
import requestInterceptor from 'interceptors/Request.interceptor'
import ReactGA from 'react-ga'
import { AppTheme } from 'styles/Theme'
import { ThemeProvider } from '@mui/material/styles'
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react'
import GlobalStyles from 'styles/GlobalStyles'
import Router from 'features/routing/Router'
import { COGNITO_PROXY_URL } from 'constants/Api.constants'
import { initializeApp } from 'firebase/app'
import { getFirebaseConfig } from 'features/firebase/Firebase.services'

if (isProdNodeEnv) {
  // Initialize React Google Analytics
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  ReactGA.initialize(GOOGLE_ANALYTICS_KEY, { debug: BUILD_ENV !== 'prod' })
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ReactGA.set({ checkProtocolTask: () => {} })
  ReactGA.send({ hitType: 'pageview', page: '/' })
}

// Firebase configuration
initializeApp(getFirebaseConfig())

// Amplify configuration
Amplify.configure(awsConfig)

// Auth configuration
Auth.configure({ endpoint: COGNITO_PROXY_URL })

// Request Interceptor
requestInterceptor()

function App(): ReactElement {
  return (
    <ThemeProvider theme={AppTheme}>
      <EmotionThemeProvider theme={AppTheme}>
        <GlobalStyles />
        <Router />
      </EmotionThemeProvider>
    </ThemeProvider>
  )
}

export default App
